/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Theme } from '@mui/material/styles';
import { TOP_BAR_HEIGHT } from '../../TopBar/TopBar';
import { StyleRules } from '@mui/styles/withStyles/withStyles';
import { SELECTED_FILTERS_PANEL_MIN_HEIGHT } from '../../FilterPanel/SelectedFiletrsPanel';
export const WIDE_FILTER_WIDTH = 256;
export const NARROW_FILTER_WIDTH = 74;
export const LIST_CAPTION_HEIGHT = 62;
export const PAGINATION_HEIGHT = 52;
export const UNFOLDED_MORE_COLOR_BAR_HEIGHT = 50;
export const UNFOLDED_LESS_COLOR_BAR_HEIGHT = 30;
export const LIST_TABLE_CONTENT_HEIGHT_VIRTUAL = 'calc(100vh - 243px)';
//TOP_BAR_HEIGHT + LIST_CAPTION_HEIGHT + PAGINATION_HEIGHT + SELECTED_FILTERS_PANEL_MIN_HEIGHT + parseInt(theme.spacing(3)) = 243

export const createListStyles = (theme: Theme): StyleRules => {
    return {
        wrapper: {
            padding: theme.spacing(0, 0, 0, 3),
            display: 'flex',
            position: 'relative',
        },
        listContainer: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            marginRight: theme.spacing(3),
            width: `calc(100% - ${WIDE_FILTER_WIDTH}px)`,
            minWidth: 370,
            overflow: 'hidden',
        },
        tableContainer: {
            maxHeight: `calc(100vh - ${
                TOP_BAR_HEIGHT + LIST_CAPTION_HEIGHT + PAGINATION_HEIGHT + parseInt(theme.spacing(3))
            }px)`,
            borderTopColor: theme.palette.text.primary,
            borderTop: '1px solid',
            borderBottomColor: theme.palette.text.primary,
            borderBottom: '1px solid',
        },
        tableContainerWithChips: {
            height: `calc(100vh - ${
                TOP_BAR_HEIGHT +
                LIST_CAPTION_HEIGHT +
                SELECTED_FILTERS_PANEL_MIN_HEIGHT +
                PAGINATION_HEIGHT +
                parseInt(theme.spacing(3))
            }px)`,
        },
        tableContainerNoScroll: {
            overflow: 'hidden',
        },
        firstCell: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(1),
        },
        middleCell: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
        lastCell: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(3),
        },
        colorBarCell: {
            padding: theme.spacing(0, 1, 0, 0),
        },
        tableBodyText: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: 'break-all',
            fontSize: 14,
            fontWeight: 400,
        },
        unavailableValue: {
            color: theme.palette.error.main,
        },
        boldText: {
            fontWeight: 700,
        },
        linkText: {
            color: theme.palette.link.main,
            textDecoration: 'underline',
        },
        clickableText: {
            color: theme.palette.link.main,
            textTransform: 'capitalize',
            paddingTop: 0,
            paddingBottom: 0,
        },
        filterTitle: {
            margin: theme.spacing(0.5, 0, 0.5, 0),
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 1.4,
        },
        filterSubTitle: {
            margin: theme.spacing(0.5, 0, 0.5, 0),
            color: theme.palette.text.secondary,
            fontSize: 16,
            fontWeight: 400,
        },
        rangeInputWrap: {
            display: 'flex',
            alignItems: 'flex-end',
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(1),
        },
        statusCheckboxItem: {
            display: 'flex',
            alignItems: 'center',
        },
        statusOrnament: {
            height: 8,
            width: 8,
            borderRadius: '50%',
            marginRight: theme.spacing(1),
        },
        preloaderBoxParent: {
            position: 'relative',
        },
        preloaderBox: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'black',
            opacity: 0.3,
            color: 'white',
            zIndex: 1099,
        },
        '@keyframes pulse': {
            '0%': {
                opacity: 1,
                transform: 'scale(1)',
            },
            '50%': {
                opacity: 0.8,
                transform: 'scale(0.97)',
            },
            '100%': {
                opacity: 1,
                transform: 'scale(1)',
            },
        },
        rowAnimation: {
            animation: `$pulse 1000ms 3 ${theme.transitions.easing.easeInOut}`,
        },
        incapacitatedRow: {
            backgroundColor: theme.palette.error.light,
            opacity: '50%',
        },
        afterKeyPagination: {
            justifyContent: 'end',
            minHeight: PAGINATION_HEIGHT,
        },
        rowsPerPagePagination: {
            marginRight: theme.spacing(1),
        },
        box: {
            marginTop: theme.spacing(2),
        },
        iconCell: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            padding: theme.spacing(0.4),
        },
        iconCellUnfoldLess: {
            padding: theme.spacing(0.2),
        },
    };
};
